module.exports = __webpack_public_path__ + "img/weixin.4408e68e.jpg";